import React from "react";
import PropTypes from "prop-types";

import { TOOLTIP_POSITIONS } from "./constants";

import styles from "./tooltip.scss";

const { tooltip_container, truncate_text, tooltip_wrapper, tooltip_content } = styles;

const Tooltip = ({ parent, content, position }) => {
    return (
        <div className={tooltip_container}>
            <span className={truncate_text}> {parent} </span>
            <div className={`${tooltip_wrapper} ${position}`}>
                <div className={tooltip_content}>{content}</div>
            </div>
        </div>
    );
};


Tooltip.defaultProps = {
    position: TOOLTIP_POSITIONS.BOTTOM_MIDDLE,
}

Tooltip.propTypes = {
    parent: PropTypes.element,
    content: PropTypes.element,
    position: PropTypes.string,
}


export default Tooltip;